import request from '@/api/request.js'

// 新增
export function RoleVSMenuInsert(data) {
    return request({
        url: '/api/role/rolevsmenuinsert',
        method: 'post',
        data: data
    })
}

// 新增
export function RoleVSMenuInsertMany(data) {
    return request({
        url: '/api/role/rolevsmenuinsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function RoleVSMenuDelete(id) {
    return request({
        url: `/api/role/rolevsmenudelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function RoleVSMenuUpdate(id, data) {
    return request({
        url: `/api/role/rolevsmenuupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function RoleVSMenuGetById(id) {
    return request({
        url: `/api/role/getrolevsmenubyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function RoleVSMenuGetList(params) {
    return request({
        url: '/api/role/getrolevsmenulist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function RoleVSMenuGetPageList(params) {
    return request({
        url: '/api/role/getrolevsmenupagelist',
        method: 'get',
        params: params
    })
}